import { NodeConnectionNames } from './../dto/NodeConnection';
import { NodeConnectionUi } from './../classes/NodeConnectionUi';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'connectionFilter',
  pure: false
})
export class ConnectionFilterPipe implements PipeTransform {
  transform(connections: NodeConnectionUi[], implemented:boolean): NodeConnectionUi[] {
    return connections.filter(x => x.Implemented == implemented)
  }

}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/connection-filter.pipe.ts